import React from "react";
import { cn } from "@/lib/utils";
import { diffWords } from "@/lib/diffWords";

/** Before → after as one readable text: removed words struck, added words marked. Never two walls of text. */
export function WordDiff({ before, after, className, testId }) {
  const parts = diffWords(before, after);
  return (
    <p className={cn("whitespace-pre-wrap text-[14.5px] leading-[1.6]", className)} data-testid={testId}>
      {parts.map((p, i) => p.kind === "same" ? <span key={i}>{p.text}</span> : p.kind === "del" ? <del key={i} className="rounded-[3px] bg-[hsl(0_70%_50%/0.1)] px-[1px] text-foreground/55 decoration-[hsl(0_60%_45%/0.6)]">{p.text}</del> : <ins key={i} className="rounded-[3px] bg-[hsl(var(--v-ok)/0.16)] px-[1px] no-underline text-foreground">{p.text}</ins>)}
    </p>
  );
}
